export const mutations = {
  setModalViewTransaction(state, payload) {
    state.modalViewTransaction = payload;
  },
  setTransactions(state, payload) {
    state.transactions = payload;
  },
  setTransaction(state, payload) {
    state.transaction = payload;
  }
};

export default {};
